module.exports = __webpack_public_path__ + "static/media/call-back.2a5d98c1.svg";